
export function socialList() {
  const itens = [
    { label: 'Facebook', url: 'https://facebook.com/correiocampos', icon: 'LuFacebook' },
    { label: 'Instagram', url: 'https://instagram.com/correiocampos', icon: 'LuInstagram' },
    { label: 'Twitter X', url: 'https://twitter.com/CorreioCampos', icon: 'LuTwitter' },
    { label: 'E-mail', url: '/contato', icon: 'LuMail' }
  ];

  return itens;
}
